import './welcome.css';
import React from "react";
import { Helmet } from "react-helmet";

const Welcome = () => {
  return (
    <div>
      <Helmet>
        <title>Welcome to Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar, Bangalore</title>
        <meta name="description" content="Welcome to Columbiaa Hospital - A leading multi-speciality hospital in Kasturi Nagar, Bangalore. We offer comprehensive healthcare services with advanced technology and expert doctors." />
        <meta name="keywords" content="Columbiaa Hospital welcome, multi-speciality hospital Bangalore, healthcare services, expert doctors, advanced medical facilities" />
      </Helmet>
      
      <section
        className="welcome-section"
        aria-labelledby="columbiaa-heading"
        role="region"
      >
        <div className="auto-container">
          {/* Section 1: Image Left - Text Right */}
          <div className="row align-items-center">
            <div
              className="col-lg-6 col-md-12 col-sm-12 text-center"
              data-aos="fade-right"
            >
              <figure className="image-box">
                <img
                  src="assets/images/resource/hospital-img.jpg"
                  alt="Columbiaa Hospital building exterior - Leading Multi-Speciality Hospital in Kasturi Nagar, Bangalore"
                  title="Columbiaa Hospital - Healthcare Excellence in Bangalore"
                  style={{ width: "100%", borderRadius: "10px" }}
                  loading="lazy"
                />
              </figure>
            </div>

            <div
              className="col-lg-6 col-md-12 col-sm-12"
              data-aos="fade-left"
            >
              <div className="sec-title">
                <h2
                  id="columbiaa-heading"
                  style={{ fontWeight: "300", textAlign: "left" }}
                  aria-label="Delivering Excellence in Healthcare at Columbiaa Hospital"
                >
                  Delivering Excellence in Healthcare at{" "}
                  <strong>Columbiaa Hospital</strong>
                </h2>
                <p style={{ textAlign: "left" }} aria-label="About Columbiaa Multi-Speciality Hospital">
                  <strong>Columbiaa Multi-Speciality Hospital</strong> is a leading healthcare provider committed to innovation, compassion, and world-class medical services. We offer personalised treatment plans backed by advanced technology and a team of dedicated experts.
                </p>
              </div>
            </div>
          </div>

          {/* Section 2: Text Left - Video Right */}
          <div className="row align-items-center mt-5">
            <div
              className="col-lg-6 col-md-12 col-sm-12"
              data-aos="fade-right"
            >
              <div className="sec-title">
                <h2 style={{ fontWeight: "300", textAlign: "left" }} aria-label="Why Choose Columbiaa Hospital">
                  Why Choose Columbiaa Hospital?
                </h2>
                <p style={{ textAlign: "left" }} aria-label="Columbiaa Hospital commitment to patient care">
                  At <strong>Columbiaa Hospital</strong>, we combine trusted care with cutting-edge treatments to ensure the best outcomes for every patient. Our focus is on continuous innovation, patient safety, and clinical excellence across all specialities.
                </p>
              </div>
            </div>

            <div
              className="col-lg-6 col-md-12 col-sm-12 text-center"
              data-aos="fade-left"
            >
              <div className="video-box">
                <video
                  width="100%"
                  height="315"
                  src="assets/images/vedio/satish.mp4"
                  title="Introduction to Columbiaa Hospital - Our Healthcare Excellence"
                  aria-label="Introduction video to Columbiaa Hospital, Kasturi Nagar, Bangalore"
                  autoPlay
                  loop
                  muted
                  controls
                  style={{
                    borderRadius: "40% 0 0 40%",
                    border: "5px solid #ddd",
                    padding: "5px",
                  }}
                >
                  <track kind="captions" label="English" srcLang="en" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Welcome;
